define('views/shared/bullet_nav/bullet_nav',["backbone",
        "views/_base/baseview",
        "text!views/shared/bullet_nav/bullet_nav.html",
], function (Backbone, BaseView, Template) {
    "use strict";

    return BaseView.extend({
        template: _.template(Template),
        scrollToTop: false,
        isRender: true,
        activityIndicator: false,
        tagName: "nav",
        className: "bullet-nav",
        events: {
            'click .js-nav-bullet' : 'onBulletClick'
        },

        initialize: function (options) {
            options = options || {};
            this.elementName = options.elementName;
            this.bulletCount = options.bulletCount || 2;
            this.activeBullet = options.activeBullet || 0; // zero-based index
            this.isVertical = options.isVertical;
            this.isInteractive = options.isInteractive == false ? false : true;
            this.callback = options.callback;

            BaseView.prototype.initialize(this);
        },

        render: function () {
            this.$el.html( this.template() );

            this.elArrBullets = this.$('.bullet-nav__bullet');

            if (this.isVertical == true) {
                this.$el.addClass('bullet-nav--vertical');
            }

            if (this.isInteractive == true) {
                this.$el.addClass('bullet-nav--interactive');
            }

            this.setActiveBullet(this.activeBullet);
            
            return this;
        },

        // This method is called by parent views
        setActiveBullet: function(index) {
            this.elArrBullets.removeClass('bullet-nav__bullet--active');
            
            var activeBullet = $( this.elArrBullets[index] );
            activeBullet.addClass('bullet-nav__bullet--active');
        },

        onBulletClick: function(e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            if (this.isInteractive == true) {
                var bulletIndex = e.target.getAttribute('data-bullet-index');
                this.setActiveBullet(bulletIndex);

                if ( $.isFunction(this.callback) ) {
                    this.callback(bulletIndex);
                }
            }
        },

        close: function () {
            
        }
    });
});
